import consola from "consola"

/**
 * Prints an info message about a pending request.
 *
 * @param {object} config - Axios config object.
 */
function printLog(config) {
  const method = config.method
  const url = config.url
  const payload = config.data
  var log = `[NETWORK]: ${method} on ${url}`

  if (typeof payload === "object") {
    log += "\n Payload : "
    try {
      log += JSON.stringify(payload)
    } catch (err) {
      log += payload
    }
  }
  consola.info(log)
}

/**
 * Saves the current StackTrace.
 *
 * @param {object} config - Axios config object.
 * @returns {object} - The config object with the newly created stack trace.
 */
function saveStackTrace(config) {
  config.errorContext = new Error("Thrown at:")
  return config
}

/**
 * The default axios request configuration.
 *
 * @param {object} config - Axios config object.
 * @returns {object} - The modified config object.
 */
export default function (config) {
  const csrf = this.$cookies.get("csrftoken")
  const cookies = this.$cookies.getAll({ parseJSON: true })

  if (csrf) config.headers["X-CSRFToken"] = csrf
  else delete config.headers["X-CSRFToken"]
  if (!process.client) {
    config.headers["Cookie"] =
      Object.keys(cookies).reduce((acc, key) => {
        return acc + `${key}=${cookies[key]};`
      }, "") || ""
  }
  printLog(config)
  return saveStackTrace(config)
}
